<app-modal class="lifecycle-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.lifecycleEditModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <app-lifecycle-form
            *ngIf="toolDetails && !isLoading"
            [toolDetails]="toolDetails"
            [showValidations]="showValidations">
        </app-lifecycle-form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isLoading"
                    (click)="clickUpdate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>
